import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import ResizeObserver from 'resize-observer-polyfill';

/*
 * A simple HOC that provides facility for listening to container resizes.
 * Adapted from React Grid Layout's width provider
 * https://github.com/STRML/react-grid-layout/blob/master/lib/components/WidthProvider.jsx
 */
export default function CustomWidthProvider( ComposedComponent ){
    return class WidthProvider extends Component{
        static defaultProps = {
            measureBeforeMount: false
        };

        static propTypes = {
            breakpoints: PropTypes.object,
            className: PropTypes.string,
            cols: PropTypes.object,
            margin: PropTypes.array,
            // If true, will not render children until mounted. Useful for getting the exact width before
            // rendering, to prevent any unsightly resizing.
            measureBeforeMount: PropTypes.bool,
            style: PropTypes.object,
        };

        state = {
            resizeObserver: new ResizeObserver( entries => {
                this.onWindowResize();
            } ),
            rowHeight: 45,
            width: 1280,
        };

        mounted = false;

        componentDidMount(){
            const reactGridLayoutEl = document.querySelector( '.react-grid-layout' );

            this.mounted = true;

            // Detect when updates to DOM or window changes size of the layout container
            this.state.resizeObserver.observe( reactGridLayoutEl );
        }

        componentWillUnmount(){
            this.mounted = false;
            this.state.resizeObserver.disconnect();
        }

        sortBreakpoints( breakpoints ){
            const keys = Object.keys( breakpoints );
            return keys.sort( function( a, b ){
                return breakpoints[a] - breakpoints[b];
            } );
        }

        currentBreakpoint( ){
            const { breakpoints } = this.props;
            const sorted = this.sortBreakpoints( breakpoints );
            let matching = sorted[0];

            for( let i = 1, len = sorted.length; i < len; i++ ){
                const breakpointName = sorted[i];
                if( this.state.width > breakpoints[breakpointName] ) matching = breakpointName;
            }

            return matching;
        }

         calcRowHeight = () => {
             const { cols, margin } = this.props;
             const columnNumber = cols[this.currentBreakpoint()];
             const height = ( this.state.width - ( margin[0] * ( columnNumber + 1 ) ) ) / columnNumber;

             return height;
         }

        onWindowResize = () => {
            if( !this.mounted ) return;
            //eslint-disable-next-line react/no-find-dom-node
            const node = ReactDOM.findDOMNode( this );
            if( node instanceof HTMLElement )
                this.setState( {
                    width: node.offsetWidth
                } );
        };

        render(){
            const { measureBeforeMount, ...rest } = this.props;
            if( measureBeforeMount && !this.mounted ){
                return (
                    <div className={this.props.className} style={this.props.style} />
                );
            }
            const rowHeight = this.calcRowHeight();

            return <ComposedComponent {...rest} {...this.state} rowHeight={rowHeight} />;
        }
    };
}
